import * as React from 'react';
import { TableCellProps } from './TableProps';

type Props = TableCellProps<any, number>;

export const IntegerCell: React.FC<Props> = ({
  value,
  formattedValue,
  column,
}) => {
  return (
    <span>
      {column?.noThousandsSeparator
        ? value
        : value !== null && value !== undefined && formattedValue}
    </span>
  );
};
